export function getViteAppServiceNowDomain(): string {
  return import.meta.env.VITE_SERVICENOW_DOMAIN;
}
